import React from 'react';
import '../styles/Loader.css';

function Loader({text}) {
  return (
    <div className="preloader column align-center justify-center">
      <div className="loader"></div>
      <p className='loader-text'>{text}</p>
    </div>    
  );
}

export default Loader;
